export const FORGET_PASSWORD = '@auth/FORGET_PASSWORD';
export const FORGET_PASSWORD_SUCCESS = '@auth/FORGET_PASSWORD_SUCCESS';
export const FORGET_PASSWORD_ERROR = '@auth/FORGET_PASSWORD_ERROR';
export const SET_FORGET_PASSWORD = '@auth/SET_FORGET_PASSWORD';
export const SET_FORGET_PASSWORD_SUCCESS = '@auth/SET_FORGET_PASSWORD_SUCCESS';
export const SET_FORGET_PASSWORD_ERROR = '@auth/SET_FORGET_PASSWORD_ERROR';
